module.exports = __webpack_public_path__ + "img/BloomLogoNew.e40c0c56.png";